import { SVGIconProps } from './types'

export const APIExplorerIcon = ({ ...props }: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28856 1.29691C7.42258 1.23436 7.57742 1.23436 7.71144 1.29691L13.7114 4.09691C13.8875 4.17906 14 4.35574 14 4.55V11.45C14 11.6443 13.8875 11.8209 13.7114 11.9031L7.71144 14.7031C7.57742 14.7656 7.42258 14.7656 7.28856 14.7031L1.28856 11.9031C1.11252 11.8209 1 11.6443 1 11.45V4.55C1 4.35574 1.11252 4.17906 1.28856 4.09691L7.28856 1.29691ZM2 5.30578L7 7.43078V13.4649L2 11.1316V5.30578ZM8 13.4649L13 11.1316V5.30578L8 7.43078V13.4649ZM7.5 6.55672L12.2719 4.52866L7.5 2.30176L2.72809 4.52866L7.5 6.55672Z"
        fill="currentColor"
      />
    </svg>
  )
}
